
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host([height-grow]) {
  display:flex;
  height:100%;
}

.location-card {
  display:flex;
  flex-grow:1;
  flex-direction:column;
  border-radius:0.75rem;
  background-color:var(--neutral-white);
  padding:1.75rem;
  box-shadow:var(--brand-shadow);
}

.location-card-top-section {
  display:flex;
  justify-content:space-evenly;
}

.location-card-info-section {
  order:2;
  display:flex;
  width:100%;
  flex-direction:column;
  justify-content:space-evenly;
}

.location-card-top-body {
  display:flex;
  min-height:128px;
  flex-direction:row;
  justify-content:space-evenly;
}

.location-card-addr-phone {
  margin-right:auto;
}

.location-card-bottom-section {
  display:flex;
  width:100%;
  flex-grow:1;
  align-items:flex-end;
}

.location-card-cta-wrapper {
  width:100%;
}

.location-card-cta-section {
  display:flex;
  flex-wrap:wrap;
  align-items:flex-end;
}

.location-card-headline, .location-card-phone, .location-card-location-link, .location-card-directions-link {
  color:var(--primary-blue-light-2);
}

.location-card-headline, .location-card-location-link, .location-card-directions-link {
  font-family:var(--ff-display);
}

.location-card-headline {
  margin-bottom:0.625rem;
  font-size:var(--fs-xl);
  line-height:var(--lh-xl);
  font-weight:var(--fw-bold);
}

.location-card-address, .location-card-hours, .location-card-hours-bottom, .location-card-feature, .location-card-phone {
  font-family:var(--ff-body);
}

.location-card-address, .location-card-hours, .location-card-hours-bottom, .location-card-feature {
  margin-bottom:0.625rem;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  color:var(--neutral-gray-1);
}

.location-card-feature {
  margin-top:0.625rem;
}

.location-card-image {
  overflow:hidden;
  border-radius:9999px;
  height:100%;
  max-height:100%;
  width:100%;
  max-width:100%;
  height:109px;
  min-height:109px;
  width:109px;
  min-width:109px;
  display:none;
}

@media (min-width: 1024px) {

  .location-card-image {
    display:block;
  }
}

.location-card-image {
  margin-left:1rem;
}

.location-card-image ::slotted(*) {
  width:100%;
}

hr {
  margin-top:1.5rem;
  margin-bottom:1.5rem;
  height:1px;
  border-style:none;
  background-color:var(--neutral-gray-4);
}

.location-card-location-link, .location-card-directions-link {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  font-weight:var(--fw-semibold);
}

.location-card-location-link {
  margin-right:1.75rem;
}

.location-card-hours {
  display:flex;
  align-items:center;
  margin-right:auto;
  border-right-width:0px;
  border-top-width:1px;
  border-bottom-width:0px;
  border-left-width:0px;
  border-style:solid;
  border-color:var(--neutral-gray-4);
}

@media (min-width: 768px) {

  .location-card-hours {
    border-left-width:1px;
  }

  .location-card-hours {
    border-top-width:0px;
  }
}

.location-card-hours {
  padding-top:0.625rem;
}

@media (min-width: 768px) {

  .location-card-hours {
    padding-left:0.875rem;
  }

  .location-card-hours {
    padding-top:0px;
  }
}

.location-card.in-sidebar {
  background-color:var(--neutral-transparent);
  padding:0px;
  --tw-shadow:0 0 #0000;
  --tw-shadow-colored:0 0 #0000;
  box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;
  box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.location-card.in-sidebar .location-card-top-section {
  display:block;
}

.location-card.in-sidebar .location-card-headline {
  font-size:var(--fs-h4-small);
  line-height:var(--lh-h4-small);
}

.location-card.in-sidebar .location-card-phone {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

.location-card.in-sidebar .location-card-top-section {
  display:flex;
}

.location-card.in-sidebar .location-card-top-section {
  flex-direction:column;
}

.location-card.in-sidebar .location-card-info-section {
  order:2;
}

.location-card.in-sidebar .location-card-image {
  order:1;
}

.location-card.in-sidebar .location-card-image {
  margin-bottom:2rem;
}

.location-card.in-sidebar .location-card-image {
  margin-left:0px;
}

.location-card.in-sidebar .location-card-image {
  display:block;
}

.location-card.in-sidebar .location-card-image {
  height:auto;
}

.location-card.in-sidebar .location-card-image {
  width:100%;
}

.location-card.in-sidebar .location-card-image {
  border-radius:0.75rem;
}

.location-card.in-sidebar .location-card-image ::slotted(*) {
  width:100%;
}

:host([site='GHS']) .location-card-addr-phone, :host([site='GHS']) .location-card-hours {
  width:50%;
}

:host([site='GHS']) .is-small .location-card-addr-phone, :host([site='GHS']) .is-small .location-card-hours {
  width:auto;
}

:host([site='GHS']) .no-hours .location-card-addr-phone, :host([site='GHS']) .no-hours .location-card-hours {
  width:auto;
}

:host([site='GHS']) .location-card-hours-bottom {
  display:none;
}

:host([site='GHS']) .is-small .location-card-hours {
  display:none;
}

:host([site='GHS']) .is-small .location-card-hours-bottom {
  display:block !important;
}

:host([site='GHS']) .is-small .location-card-hours-bottom {
  border-right-width:0px;
}

:host([site='GHS']) .is-small .location-card-hours-bottom {
  border-top-width:1px;
}

:host([site='GHS']) .is-small .location-card-hours-bottom {
  border-bottom-width:0px;
}

:host([site='GHS']) .is-small .location-card-hours-bottom {
  border-left-width:0px;
}

:host([site='GHS']) .is-small .location-card-hours-bottom {
  border-style:solid;
}

:host([site='GHS']) .is-small .location-card-hours-bottom {
  border-color:var(--neutral-gray-4);
}

:host([site='GHS']) .is-small .location-card-hours-bottom {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

:host([site='GHS']) .is-small .location-card-hours-bottom {
  padding-top:0.625rem;
}

:host([site='BH']) .location-card {
  width:auto;
}

:host([site='BH']) .location-card {
  max-width:28rem;
}

:host([site='BH']) .location-card {
  border-radius:0.375rem;
}

:host([site='BH']) .location-card {
  border-width:1px;
}

:host([site='BH']) .location-card {
  border-style:solid;
}

:host([site='BH']) .location-card {
  border-color:var(--bh-neutral-default);
}

:host([site='BH']) .location-card {
  --tw-shadow:0 0 #0000;
  --tw-shadow-colored:0 0 #0000;
  box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;
  box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

:host([site='BH']) .location-card.in-sidebar {
  width:100%;
}

:host([site='BH']) .location-card.in-sidebar {
  max-width:none;
}

:host([site='BH']) .location-card.in-sidebar {
  border-style:none;
}

:host([site='BH']) .location-card.in-sidebar {
  background-color:var(--neutral-transparent);
}

:host([site='BH']) .location-card.in-sidebar {
  padding:0px;
}

:host([site='BH']) .location-card.in-sidebar {
  --tw-shadow:0 0 #0000;
  --tw-shadow-colored:0 0 #0000;
  box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;
  box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

:host([site='BH']) .location-card-headline, :host([site='BH']) .location-card-address, :host([site='BH']) .location-card-phone {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .location-card-headline, :host([site='BH']) .location-card-address, :host([site='BH']) .location-card-phone {
  font-weight:var(--fw-normal);
}

:host([site='BH']) .location-card-headline, :host([site='BH']) .location-card-address, :host([site='BH']) .location-card-phone {
  color:var(--bh-neutral-black);
}

:host([site='BH']) .location-card-headline {
  font-size:var(--bh-fs-heading-03);
  line-height:var(--bh-lh-heading-03);
  letter-spacing:var(--bh-ls-heading-03);
}

:host([site='BH']) .location-card-headline {
  font-weight:var(--fw-bold);
}

:host([site='BH']) .location-card-headline {
  color:var(--bh-brand-primary-default-compatibility);
}

:host([site='BH']) .location-card-address, :host([site='BH']) .location-card-phone {
  font-size:var(--bh-fs-body-01);
  line-height:var(--bh-lh-body-01);
  letter-spacing:var(--bh-ls-body-01);
}

:host([site='BH']) .location-card-address, :host([site='BH']) .location-card-phone {
  font-weight:var(--fw-normal);
}

:host([site='BH']) .location-card-address {
  margin-bottom:0.875rem;
}

:host([site='BH']) .location-card-phone ::slotted(*) {
  display:flex;
}

:host([site='BH']) .location-card-phone ::slotted(*) {
  align-items:center;
}

:host([site='BH']) .location-card-phone ::slotted(*) {
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
}

:host([site='BH']) .location-card-phone ::slotted(*) {
  font-weight:var(--fw-semibold);
}

:host([site='BH']) .location-card-phone ::slotted(*) {
  color:var(--bh-brand-primary-default);
}

:host([site='BH']) .location-card-phone ::slotted(ghs-icon) {
  margin-left:0.5rem;
}

:host([site='BH']) hr {
  background-color:var(--bh-neutral-default);
}
`;